import Profile from "../../model/profile";
import * as actionType from "./actionTypes";

export const setProfile = (profile: Profile | null) => {
  return {
    type: actionType.SET_PROFILE,
    payload: {
      profile,
    },
  };
};
